import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useQuery } from '@powersync/react';
import { useClinicCtx } from '@/app/state';
import { Empty, Input } from '@/components/ui';
import { searchPatients, ageLabel } from '@/features/patients/repo';
import type { PatientIndexRow } from '@/lib/db/schema';
import { formatPhoneLocal } from '@/lib/myanmar/phone';

export function PatientsPage() {
  const { t, i18n } = useTranslation();
  const my = i18n.language === 'my';
  const ctx = useClinicCtx();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState<PatientIndexRow[]>([]);
  const { data: tick } = useQuery('select count(*) as n from patient_index where clinic_id = ?', [ctx.clinicId]);
  useEffect(() => { void searchPatients(ctx.db, ctx.clinicId, q, 100).then(setRows); }, [q, ctx.db, ctx.clinicId, tick]);
  return (
    <div className="grid gap-3">
      <Input autoFocus placeholder={t('patient.searchHint')} value={q} onChange={(e) => setQ(e.target.value)} className="text-lg" />
      {rows.length === 0 ? <Empty>{t('patient.noResults')}</Empty> : (
        <div className="overflow-x-auto rounded-xl border border-rule bg-surface">
          <table className="w-full text-left text-sm">
            <thead className="bg-bg text-xs uppercase tracking-wide text-muted"><tr><th className="px-4 py-2">{t('patient.number')}</th><th className="px-4 py-2">{t('patient.nameMy')}</th><th className="px-4 py-2">{t('patient.nameEn')}</th><th className="px-4 py-2">{t('patient.age')}</th><th className="px-4 py-2">{t('patient.phone')}</th></tr></thead>
            <tbody>
              {rows.map((p) => { const a = ageLabel(p); const ph = (JSON.parse(p.phones ?? '[]') as string[])[0]; return (
                <tr key={p.id} className="border-t border-rule">
                  <td className="px-4 py-2 font-mono"><Link className="hover:underline" to={`/patients/${p.patient_id}`}>{p.patient_no}</Link></td>
                  <td className="px-4 py-2 font-my">{p.name_my}</td>
                  <td className="px-4 py-2">{p.name_en}</td>
                  <td className="px-4 py-2">{a ? a.years : ''}</td>
                  <td className="px-4 py-2">{ph ? formatPhoneLocal(ph) : ''}</td>
                </tr>); })}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-xs text-muted">{my ? 'အမည်ရှာဖွေမှုကို ဒီစက်ပေါ်တွင်သာ လုပ်သည်။ ဆာဗာသည် စာဝှက်ထားသော ဒေတာသာ သိမ်းသည်။' : 'Name search runs on this device only. The server stores encrypted data.'}</p>
    </div>
  );
}
